import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useProjectsContext } from '@/providers/projects-provider';
import { getProcessingStatus } from '@/api/generated/projects/projects';
import { GetProjectConfigurationReq } from '@/api/generated/model';
export type ProcessingStatus = 'waiting_for_processing' | 'waiting_for_interactions' | 'loading' | 'processed' | 'processing' | 'error';
export interface ProcessingStatusData {
  status: ProcessingStatus;
  rowsInProcessing?: number;
  rowsProcessed?: number;
  step?: string;
  lastUpdated?: string | null;
}
export const useProcessingStatus = () => {
  const $ = _c(18);
  const {
    selectedProject
  } = useProjectsContext();
  selectedProject?.id;
  const t0 = selectedProject?.id ?? "";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      project_id: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const payload = t1;
  const t2 = selectedProject?.id;
  let t3;
  if ($[2] !== t2) {
    t3 = ["projectProcessingStatus", t2];
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== payload) {
    t4 = () => getProcessingStatus(payload);
    $[4] = payload;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !!selectedProject?.id;
  let t6;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5
    };
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const {
    data,
    isLoading,
    isFetching
  } = useQuery(t6);
  selectedProject?.id;
  let t7;
  bb0: {
    if (isLoading || isFetching || !selectedProject?.id) {
      let t8;
      if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
          status: "loading"
        };
        $[10] = t8;
      } else {
        t8 = $[10];
      }
      t7 = t8;
      break bb0;
    }
    if (!data?.status) {
      let t8;
      if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
          status: "error"
        };
        $[11] = t8;
      } else {
        t8 = $[11];
      }
      t7 = t8;
      break bb0;
    }
    const responseStatus = data.status;
    const rowsInProcessing = responseStatus.rows_in_processing ?? 0;
    const rowsProcessed = responseStatus.rows_processed ?? 0;
    const lastUpdated = responseStatus.last_updated ?? null;
    const categoryName = responseStatus.category_name;
    const state = responseStatus.state;
    const step = categoryName === "interactions" ? "1/2" : "2/2";
    let status;
    bb1: switch (state) {
      case "completed":
        {
          status = "processed";
          break bb1;
        }
      case "processing":
        {
          status = "processing";
          break bb1;
        }
      case "waiting_for_interactions":
        {
          status = "waiting_for_interactions";
          break bb1;
        }
      case "waiting_for_processing":
        {
          status = "waiting_for_processing";
          break bb1;
        }
      default:
        {
          status = "error";
        }
    }
    let t8;
    if ($[12] !== lastUpdated || $[13] !== rowsInProcessing || $[14] !== rowsProcessed || $[15] !== status || $[16] !== step) {
      t8 = {
        status,
        rowsInProcessing,
        rowsProcessed,
        step,
        lastUpdated
      };
      $[12] = lastUpdated;
      $[13] = rowsInProcessing;
      $[14] = rowsProcessed;
      $[15] = status;
      $[16] = step;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    t7 = t8;
  }
  return t7;
};